<template>
  <div class="behavior-profile" v-loading="loading">
    <div v-if="loaded && profile" class="profile-body">
      <el-row :gutter="12" class="score-row">
        <el-col :span="6">
          <div class="score-item">
            <div class="score-num">{{ intentScore }}</div>
            <div class="score-label">意向分</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="score-item">
            <div class="score-num" :class="intentLevelClass">{{ intentLevel }}</div>
            <div class="score-label">意向等级</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="score-item">
            <div class="score-num">{{ activeScore }}</div>
            <div class="score-label">活跃分</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="score-item">
            <div class="score-num main">{{ mainInterestName }}</div>
            <div class="score-label">主兴趣</div>
          </div>
        </el-col>
      </el-row>

      <div class="tags" v-if="tags.length">
        <el-tag
          v-for="(t, i) in tags"
          :key="i"
          size="small"
          class="tag"
          effect="plain"
        >{{ t }}</el-tag>
      </div>

      <div class="stats">
        <span>看视频 {{ videoWatchCount }} 次</span>
        <span>完播 {{ videoCompleteCount }} 次</span>
        <span>互动 {{ videoInteractCount }} 次</span>
      </div>

      <div class="recent" v-if="recentEvents.length">
        <div class="recent-title">最近短视频行为</div>
        <el-table :data="recentEvents" size="mini" border>
          <el-table-column label="行为" width="100" align="center">
            <template slot-scope="scope">{{ eventName(scope.row.eventType) }}</template>
          </el-table-column>
          <el-table-column label="视频" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.videoTitle || ('视频#' + scope.row.videoId) }}
            </template>
          </el-table-column>
          <el-table-column label="时间" width="140" align="center">
            <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="empty-tip" v-else>暂无短视频行为明细</div>
    </div>
    <div v-else-if="loaded" class="empty-tip">暂无画像数据，等待客户观看短视频后生成</div>
  </div>
</template>

<script>
import { queryUserBehaviorProfile } from '@/api/videoManage'

const EVENT_NAMES = {
  expose: '曝光',
  play_start: '开始播放',
  play_progress: '播放进度',
  play_complete: '完播',
  like: '点赞',
  comment: '评论',
  share: '分享',
  chat: '聊一聊',
  follow: '关注'
}

export default {
  name: 'BehaviorProfile',
  props: {
    userId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      loaded: false,
      profile: null,
      tags: [],
      intentLevel: '低',
      mainInterestName: '暂无',
      recentEvents: []
    }
  },
  computed: {
    intentScore() {
      return (this.profile && this.profile.intentScore) || 0
    },
    activeScore() {
      return (this.profile && this.profile.activeScore) || 0
    },
    videoWatchCount() {
      return (this.profile && this.profile.videoWatchCount) || 0
    },
    videoCompleteCount() {
      return (this.profile && this.profile.videoCompleteCount) || 0
    },
    videoInteractCount() {
      return (this.profile && this.profile.videoInteractCount) || 0
    },
    intentLevelClass() {
      const map = { '高': 'lv-high', '中': 'lv-mid', '低': 'lv-low' }
      return map[this.intentLevel] || 'lv-low'
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler() {
        this.loadProfile()
      }
    }
  },
  methods: {
    async loadProfile() {
      const uid = Number(this.userId) || 0
      if (!uid) {
        this.loaded = true
        this.profile = null
        return
      }
      this.loading = true
      try {
        const res = await queryUserBehaviorProfile({ userId: uid, recentLimit: 10 })
        const data = (res && res.data) || null
        this.loaded = true
        if (!data) {
          this.profile = null
          return
        }
        this.profile = data.profile || null
        this.tags = data.tags || []
        this.intentLevel = data.intentLevel || '低'
        this.mainInterestName = data.mainInterestName || '暂无'
        this.recentEvents = data.recentEvents || []
      } catch (e) {
        this.loaded = true
        this.profile = null
      } finally {
        this.loading = false
      }
    },
    eventName(type) {
      return EVENT_NAMES[type] || type || '-'
    },
    formatTime(t) {
      if (!t) return ''
      const s = String(t).replace('T', ' ')
      return s.length > 16 ? s.substring(5, 16) : s
    }
  }
}
</script>

<style scoped lang="scss">
.behavior-profile {
  padding: 16px 20px 20px;
  min-height: 280px;
}
.score-item {
  text-align: center;
  background: #f7fafa;
  border-radius: 8px;
  padding: 14px 8px;
  margin-bottom: 8px;
}
.score-num {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  min-height: 32px;
  &.main { font-size: 18px; color: #2f6bff; }
  &.lv-high { color: #e34d59; }
  &.lv-mid { color: #ed7b2f; }
  &.lv-low { color: #8a8a8a; }
}
.score-label {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
}
.tags {
  margin-top: 12px;
  .tag { margin: 0 8px 8px 0; }
}
.stats {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 13px;
  color: #666;
}
.recent {
  margin-top: 18px;
}
.recent-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}
.empty-tip {
  text-align: center;
  color: #a2a6a8;
  padding: 40px 0;
  font-size: 13px;
}
</style>
